export const getCode = "/api/v1/union/agent/sms";
// 分销
export const goodList = "/api/v1/union/agent/product/list";
// 添加商品
export const addGood = "/api/v1/union/agent/product/add_update";
// 删除商品
export const deleGood = "/api/v1/union/agent/product/delete";
// 代理商列表
//export const daili_list='/api/v1/union/agent/list';
// export const daili_list='/api/v1/union/agent/subagent_list'              //  要更换了  在新版下面
// 网吧列表
// export const bar_list = '/api/v1/union/agent/cybar_list'
export const bar_list = "/api/v1/new_mgr/bar_list";
// 创建代理商
//export const create_agent='/api/v1/union/agent/add_update';
// 创建代理商
export const create_agent = "/api/v1/union/agent/update";
//包月订单
export const month_order = "/api/v1/union/orders/list";
// 扫码订单
export const month_sao = "/api/v1/new_mgr/sm_order_list";
//手机版订单
export const mobile_order = "/api/v1/app/order/list";
//条件查询
export const searchList = "/api/v1/union/agent/condition_list";
//下级代理商查询
export const next_search = "/api/v1/union/agent/sub_query";
//下级查询统计
export const next_tj = "/api/v1/union/agent/sub_statistic";
//代理商启用禁用删除
//export const dele_use='/api/v1/union/agent/operation';
export const dele_use = "/api/v1/union/agent/operate_agent";
// 下单
export const recharge = "/api/v1/union/orders/create";
// 检验状态
export const checkStatus = "/api/v1/union/orders/status";

//分层列表  新版
export const shareDataList = "api/v1/new_mgr/sm_order_fc_next";
// /api/v1/new_mgr/sm_order_list
//  提现列表
export const sm_order_fc_self = "api/v1/new_mgr/sm_order_fc_self";

// 订单列表
export const sm_order_list = "/api/v1/new_mgr/sm_order_list";

//  获取验证码
export const alipay_code = "api/v1/new_mgr/alipay_code";

//  是否需要绑定支付宝账号

export const read_alipay = "api/v1/new_mgr/read_alipay";

// export const apply_money='api/v1/new_mgr/apply_money';
// 保存支付宝信息
export const input_alipay = "api/v1/new_mgr/input_alipay";

// 支付宝提现

export const apply_money = "api/v1/new_mgr/apply_money";

// 提现列表
export const apply_money_rude = "api/v1/new_mgr/apply_money_rude";

// 代理商列表
export const daili_list = "/api/v1/new_mgr/new_agent_list";

// 查看公告
export const notice = "/api/v1/new_mgr/notice";

// 查看首页的分成数据

export const sm_day_month_money = "/api/v1/new_mgr/sm_day_month_money";

// 查看图表接口
export const sm_fc_self_month = "/api/v1/new_mgr/sm_fc_self_month";

// 创建代理商
export const new_register = "/api/v1/new_mgr/new_register";

// 修改密码

export const set_pwd = "/api/v1/new_mgr/set_pwd";

// 登录
export const login = "/api/v1/new_mgr/login";

// 渠道扫码
export const person_order = "/api/v1/new_mgr/person_order";

// 渠道包下载
export const sm_downloads = "/api/v1/new_file/sm_downloads";

// 提现审核表
export const admin_apply_money_rude = "/api/v1/new_mgr/admin_apply_money_rude";

// 提现状态
export const admin_alipay_status = "/api/v1/new_mgr/admin_alipay_status";

// 获取群qq
export const read_qq = "/api/v1/new_mgr/read_qq";

// 发送短信验证码

export const apply_code = "/api/v1/new_mgr/apply_code";

// 注册
export const submit = "/api/v1/new_mgr/submit";

// 查看有效终端的列表数据
export const read_mac = "/api/v1/new_mgr/read_mac";

// 有效终端开关server_model.ChannelOpenClose
export const open_close = "/api/v1/new_mgr/open_close";

//  查看昨天，今天，本月有效终端的数据
export const month_day_mac = "/api/v1/new_mgr/month_day_mac";

// 提现管理 第一个页面接口
export const new_agent_list_order = "/api/v1/new_mgr/new_agent_list_order";
//包月分成管理
export const bar_order_fc = "/api/v1/new_mgr/bar_order_fc";

export const sm_order_excel = "/api/v1/new_mgr/sm_order_excel";
export const new_agent_list_order_excel =
  "/api/v1/new_mgr/new_agent_list_order_excel";
export const bar_order_fc_excel = "/api/v1/new_mgr/bar_order_fc_excel";

export const noPasswordLogin = "/other/login";

// 查看mac
export const mac_fc_self = "/api/v1/new_mgr/mac_fc_self";

//mac总和
export const self_sum_mac = "/api/v1/new_mgr/self_sum_mac";

//田家网吧
export const addBar = "/api/v1/union/cyber/add_bar";

//首页统计
export const firstMessage = "/api/v1/union/statics/info";
export const getLineData = "/api/v1/union/statics/index_fxdatabymonth";
//消息通知条数
export const getIndexInfos = "/api/v1/union/statics/index_reddot";
//消息内容
export const getIndexMsg = "/api/v1/union/statics/index_getmessage";
//提交读取消息
export const setIndexMsg = "/api/v1/union/statics/index_readmessage";

//下载
export const down = "/api/v1/union/agent/download";
//退出
export const loginOut = "/api/v1/union/agent/logout";
//版本列表
export const versionRelease = "/api/v1/union/version/list";
// 添加版本
export const versionAdd = "/api/v1/union/version/update";
//下载
export const versionDownload = "/api/v1/union/version/download";
//固定网吧id
export const barId = "api/v1/union/cyber/get_barId";
//账号统计
export const accountNumber = "/api/v1/union/agent/accmgr_statist";
//删除网吧
export const bardel = "/api/v1/union/cyber/del_bar";
//修改密码
export const changePassword = "/api/v1/union/agent/setpwd";
//订单统计总额
export const accountAll = "/api/v1/union/agent/order_statistic";
//编辑网吧
export const changeBar = "/api/v1/union/cyber/update_bar";

// 管理员增减网吧的到期时间
export const add_bar_time = "/api/v1/new_mgr/add_bar_time";
export const update_bar_num = "/api/v1/new_mgr/update_bar_num";
//编辑网吧名称
export const rename_bar = "/api/v1/new_mgr/update_name";
export const reset_password = "/api/v1/new_mgr/reset";
//下载包月配置文件
export const downloadby_profile = "/api/v1/new_file/bar_config";
